











































































import {Component, Prop, Vue} from "vue-property-decorator";
import {Maintenance} from "@/models/maintenance";
import ImageRepository from "@/api/ImageRepository";
import { RepositoryFactory } from "@/api/RepositoryFactory";

const imageRepository: ImageRepository = RepositoryFactory.get('image');

@Component({
  components: {
    ImageGalleryComponent: () => import('./dialog/MaintenanceImageGalleryDialog.component.vue'),
    DocumentPdfDialogComponent: () => import('./dialog/DocumentPdfDialog.component.vue')
  }
})
export default class MachineMaintenanceTableRowComponent extends Vue {

  @Prop({default: new Maintenance({})})
  public maintenance!: Maintenance;

  @Prop({default: () => []})
  public selectedRows!: Maintenance[];

  public imageDialog = false;
  public documentPdfDialog = false;
  public maintenanceListDialog = false;
  public dialogDelete = false;

  public isSelected = false;

  public images: any[] = [];
  
  public async openImages() {
    const images = await imageRepository.getImagesByMaintenance(this.maintenance.id);
    console.log('images', images.data);
    this.maintenance.maintenanceImages = images.data;
    
    this.imageDialog = true
  }

  public openDocumentPdf() {
    this.documentPdfDialog = true;
  }

  public closeImageGalleryDialog() {
    this.imageDialog = false;
  }

  public closeDocumentPdfDialog() {
    this.documentPdfDialog = false;
  }

  public selectedCheckbox() {
    if (this.isSelected) {
      const findIndex = this.selectedRows.findIndex(maintenance => maintenance.id === this.maintenance.id);
      this.selectedRows.splice(findIndex, 1);
      this.isSelected = false;
    } else {
      this.selectedRows.push(this.maintenance);
      this.isSelected = true;
    }
  }

  public get hasDocumentPdfs(): boolean {
    return this.maintenance && this.maintenance.documentPdfs && this.maintenance.documentPdfs.length > 0;
  }

}
